import React, { useState } from 'react'
import { ContBtn, ImgIcon } from '../../pages/flashcard/singleFlashcard/styles'
import replayIcon from "../../assets/icons/replay.png";

function ReplayBtn({ onClick }) {
    const [rotate, setRotate] = useState(false)
    return (
        <ContBtn
            onClick={() => {
                onClick?.();
                setRotate(true);
                setTimeout(() => setRotate(false), 500);
            }}
        >
            <ImgIcon style={rotate ? {
                transform: 'rotate(-360deg)',
                transitionDuration: "500ms",
            } : {}} src={replayIcon} alt="play" />
        </ContBtn>
    )
}

export default ReplayBtn